import {Component, EventEmitter, NgZone, OnInit, Output, ViewChild} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Vehicle} from '../../models/vehicle';
import {VehiclesHandlerService} from '../../api-handlers/vehicles-handler.service';
import {TechnicalShutdown} from '../../models/technical_shutdown';

@Component({
	selector: 'app-create-fermo-tecnico',
	templateUrl: './create-fermo-tecnico.component.html',
	styleUrls: ['./create-fermo-tecnico.component.css']
})
export class CreateFermoTecnicoComponent implements OnInit {
	@ViewChild('template', {static: false}) template;
	@Output() fermoCreated = new EventEmitter();
	modalRef: BsModalRef;
	vehicle: Vehicle;
	technicalShutdown: TechnicalShutdown;
	dom_elements = { };
	
	constructor(
		private modalService: BsModalService,
		private vehicleHandler: VehiclesHandlerService,
		private ngZone: NgZone) { }
	
	ngOnInit() {
		this.resetDomElements();
	}
	
	resetDomElements() {
		this.dom_elements = {
			'from': new Date(),
			'to': new Date(),
			'title': '',
			'known_to': false,
		};
		
	}
	showDialog(obj: any) {
		this.technicalShutdown = obj.technicalShutdown;
		this.vehicle = obj.vehicle;
		this.resetDomElements();
		
		if (this.technicalShutdown.id) {
			this.dom_elements['title'] = 'Modifica';
			if (this.technicalShutdown.to) {
				this.dom_elements['known_to'] = true;
			}
		} else {
			this.dom_elements['title'] = 'Crea';
			this.technicalShutdown.to = null;
		}
		this.modalRef = this.modalService.show(this.template, { class: 'modal-lg' });
		
	}
	
	create() {
		if (this.technicalShutdown.id) {
			this.vehicleHandler.editTechnicalShutdown(this.technicalShutdown).then((techShut) => {
				this.fermoCreated.emit(this.vehicle);
				this.modalRef.hide();
			});
		} else {
			this.vehicleHandler.createTechnicalShutdown(this.technicalShutdown).then((techShut) => {
				this.fermoCreated.emit(this.vehicle);
				this.modalRef.hide();
			});
		}
	}
	
	resetTo() {
		this.technicalShutdown.to = null;
	}
}
